import React from 'react';
export function Footer() {
  return <footer className="bg-[#050b14] py-6 border-t border-gray-900" data-id="element-66">
      <div className="max-w-5xl mx-auto px-3 sm:px-6 text-center" data-id="element-67">
        <p className="text-gray-500 text-xs sm:text-sm mb-2" data-id="element-68">
          © 2026 KIT COMPLETO GEOGRAFÍA LISTA ™
        </p>
        <div className="flex justify-center space-x-4 text-xs sm:text-sm text-gray-600" data-id="element-69">
          <span className="cursor-pointer hover:text-gray-400 transition-colors" data-id="element-70">
            Términos
          </span>
          <span className="cursor-pointer hover:text-gray-400 transition-colors" data-id="element-71">
            Privacidad
          </span>
          <span className="cursor-pointer hover:text-gray-400 transition-colors" data-id="element-72">
            Soporte
          </span>
        </div>
      </div>
    </footer>;
}